import React from "react";
import './squareWarningMessage.scss';
export default function SquareWarningMessage(_a) {
    var message = _a.message;
    return React.createElement("div", { className: "warning-callout" },
        React.createElement("span", { className: "warning-callout__icon" }, "\u26A0"),
        message);
}
